import { ValidationError } from "@checkout/validation";

export interface CreateCheckoutBasketResponse {
  basketId: string;
  isExisting: boolean;
  message?: string;
  clientSecret?: string;
  validationError?: ValidationError;
}

export interface BasketConflictResponse {
  existingBasket: string;
  message: string;
}

export enum IntentClientSecretType {
  SETUP = "SETUP",
  PAYMENT = "PAYMENT",
}
